import { api } from './api.js';

/*
 * The tenant side of the company surface: GET/PATCH /api/company (server/src/routes/company.ts),
 * which act on the CALLER'S OWN company — as opposed to src/lib/adminApi.ts's
 * /api/admin/companies/*, where an admin acts on any company by id. Neither route here takes an
 * id: the tenant is resolved from the session by requireCompany(), and for a recruiter holding
 * more than one membership it comes from the ?companyId= that src/lib/api.ts threads on.
 */

export interface Company {
  id: string;
  slug: string;
  name: string;
  website: string;
  description: string;
  status: string;
  companyRole: 'owner' | 'member';
  complete: boolean;
}

export const getCompany = () => api<{ company: Company }>('/api/company');

/*
 * name/website/description only. The server's companyPatchSchema is `.strict()` and carries
 * neither `slug` (the tenant's public handle, admin business) nor `status` (suspension is
 * one-way and admin-only), so sending either is a 400, not a silent no-op.
 *
 * PATCH is owner-only: a member gets 403 insufficient_company_role.
 */
export const patchCompany = (body: { name?: string; website?: string; description?: string }) =>
  api<{ company: Company }>('/api/company', { method: 'PATCH', body });
